<template>
  <div class="schoolPoster" @click.self="hide()" v-if="show_view">
    <div class="schoolPosterContainer">
      
      <div class="rightView">
        <div id="qrcode" ref="qrcode"></div>
        <p class="content">
          打开手机，扫描二维码<br />分享给好友，免费教ta学编程<br/>并且各自奖励 1000 蓝钻
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import QRCode from "qrcodejs2";
import { Utils } from "@/utils";

export default {
  name: "SchoolPoster",
  components: {},
  props: {},
  data() {
    return {
      show_view: false,
      poster_url: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    show(school_id, inviter_id) {
      let host = "";
      if (location.host.includes("coding61.com")) {
        host = "www.coding61.com";
      } else {
        host = "app.bcjiaoyu.com";
      }
      let url = `https://${host}/mobile/html/wxlogin.html?school_id=${school_id}&inviter_id=${inviter_id}&ret=https://www.coding61.com/index/`;
      // console.log(url);
      this.show_view = true;
      this.poster_url = url;

      this.$nextTick(()=>{
          this.qrcode()
      })
      
    },
    hide() {
        this.$refs.qrcode.innerHTML = ''
        this.show_view = false;
    },
    qrcode() {
      let qrcode = new QRCode("qrcode", {
          width:150,
          height:150,
        text: this.poster_url, // 二维码地址
        // colorDark: "#000",
        // colorLight: "#fff"
      });
    }
  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.schoolPoster {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .schoolPosterContainer {
    min-width: 300px;
    width: 30%;
    height: 50%;
    overflow: auto;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    // padding: 20px;
    border-radius: 25px;
    border: solid 10px #6b45e1;
    .leftView {
      width: 50%;
      height: 100%;
      margin-right: 20px;
      iframe {
        width: 100%;
        height: 100%;
        background-color: #f2f2f2;
      }
    }
    .rightView {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .qrcode {
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
        // margin-top: 20px;
      }
      #qrcode{
        margin-bottom: 20px;
        // margin-top: 20px;
      }
      .content {
        color: #333333;
        font-size: 15px;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}
</style>
